import { useState } from "react";

// Campo de contraseña con el botón de mostrar/ocultar.
// Escribir una contraseña a ciegas en el móvil es donde más gente se equivoca
// y acaba pensando que "la web no funciona".

const Ojo = ({ abierto }) =>
  abierto ? (
    // ojo tachado: la contraseña está a la vista, pulsar la oculta
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M3 3l18 18" />
      <path d="M10.6 5.2A9.6 9.6 0 0112 5c5 0 9 4.5 9 7 0 .9-.5 2-1.4 3.1M6.5 6.8C4 8.3 3 10.4 3 12c0 2.5 4 7 9 7 1.6 0 3-.4 4.3-1.1" />
      <path d="M9.9 9.9a3 3 0 004.2 4.2" />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M3 12s3.6-7 9-7 9 7 9 7-3.6 7-9 7-9-7-9-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

export const PasswordField = ({ value, onChange, placeholder, testId = "password-input", autoComplete = "current-password", mostrarLabel = "Mostrar contraseña", ocultarLabel = "Ocultar contraseña" }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        type={visible ? "text" : "password"}
        className="input-dark !pr-12"
        placeholder={placeholder}
        value={value}
        autoComplete={autoComplete}
        onChange={onChange}
      />
      <button
        type="button"
        data-testid={`${testId}-toggle`}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? ocultarLabel : mostrarLabel}
        title={visible ? ocultarLabel : mostrarLabel}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-zinc-500 hover:text-[#C5A059] transition-colors duration-300"
      >
        <Ojo abierto={visible} />
      </button>
    </div>
  );
};
